import { fileUrlFromPath } from "@opencode-ai/core/util/path"
import type { FilePart } from "@opencode-ai/sdk/v2"

// A user attachment that lives on disk as a real file — a path-reference upload
// (file:// url, e.g. a .pptx attached by path), a localPath captured at attach
// time (any mime, including a text/plain-normalized .txt/.md/.json), or an
// @-mention file source. When present the chip renders as a file:// anchor: the
// desktop shell's global click delegate reveals it in Finder and
// electron-context-menu offers Open / Show in Folder / Copy path — the same
// affordance as an absolute-path chip in assistant text.
//
// Deliberately mime-agnostic: earlier this only fired for non-text mimes, so a
// dragged/picked .json or .md (normalized to text/plain by attachmentMime) got
// no menu at all — the reported bug. An attachment WITHOUT a resolvable path
// (a base64-only upload, or a synthetic CSV/transcript pill, which never gets a
// localPath) has no href here and keeps the in-app preview/download instead —
// see the `href` gate at the call site.
export function attachmentFileHref(file: Pick<FilePart, "url" | "localPath" | "source">): string | undefined {
  if (file.url?.startsWith("file:")) return file.url
  if (file.localPath) return fileUrlFromPath(file.localPath)
  // fileUrlFromPath (not bare encodeURI) so a Windows source path becomes a
  // valid file:///C:/… URL rather than a slash-less, unusable one.
  if (file.source?.type === "file" && file.source.path) return fileUrlFromPath(file.source.path)
  return undefined
}
